import { render, staticRenderFns } from "./addnew_category.vue?vue&type=template&id=6939303f&"
import script from "./addnew_category.vue?vue&type=script&lang=js&"
export * from "./addnew_category.vue?vue&type=script&lang=js&"
import style0 from "./addnew_category.vue?vue&type=style&index=0&id=6939303f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports